import store from '../store'

const axios = require('axios')

export default {
   saveImage(params) {
      console.log('OXS FS SAVE')
      console.log(params)
      return axios
         .post(`${process.env.BASE_URL_API}/api/fileSystem`, params, {
            headers: { authorization: localStorage['at'] },
         })
         .then(res => {
            console.log('SAVED')
            console.log(res)
            return res
         })
   },
   saveDocument(params) {
      console.log('OXS FS SAVE')
      console.log(params)
      return axios
         .post(`${process.env.BASE_URL_API}/api/fileSystem`, params, {
            headers: { authorization: localStorage['at'] },
         })
         .then(res => {
            console.log('SAVED')
            console.log(res)
            return res
         })
   },
   get(params) {
      console.log('OXS FS GET')
      console.log(params)
      return axios
         .post(`${process.env.BASE_URL_API}/api/fileSystem/getFile`, params, {
            headers: { authorization: localStorage['at'] },
         })
         .then(res => {
            console.log('GET RESPONSE')
            console.log(res)
            return res.data
         })
   },
   async upload(ev, subDir, cb) {
      let building = store.getters.building
      let apartment = store.getters.apartment
      let companyId = store.getters.companyId
      let uploaded = ev.target.files || ev.dataTransfer.files

      let path = `${companyId}${building ? '/' + building._id : '/'}${apartment ? '/' + apartment._id : subDir ? subDir : ''
         }`

      if (uploaded[0].type.includes('image')) {
         path += `/images`

         await this.getBase64(ev, base => {
            this.saveImage({
               filePath: base,
               fileName: uploaded[0].name,
               path,
               type: uploaded[0].type,
               callback: `${process.env.BASE_URL_API}/${cb}`,
               callbackData: {
                  image: {
                     image: `${path}/${uploaded[0].name}`,
                  },
                  buildingId: building ? building._id : null,
                  companyId,
                  apartmentId: apartment ? apartment._id : null,
               },
            })
         })
      } else {
         path += `/documents`
         let fileName = this.checkDocType(ev, path)
         if (fileName)
            await this.uploadDocument(uploaded[0], base => {
               this.saveImage({
                  filePath: base,
                  fileName: fileName,
                  type: uploaded[0].type,
                  path,
                  callback: `${process.env.BASE_URL_API}/${cb}`,
                  callbackData: {
                     image: {
                        image: `${path}/${fileName}`,
                     },
                     buildingId: building ? building._id : null,
                     companyId,
                     apartmentId: apartment ? apartment._id : null,
                  },
               })
            })
      }
   },
   checkDocType(ev) {
      let uploaded = ev.target.files || ev.dataTransfer.files
      let allowed = ['pdf', 'xlsx', 'doc', 'docx', 'ppt', 'pptx']
      let type = null
      if (
         uploaded[0].type ===
         'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
         uploaded[0].type ===
         'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
         uploaded[0].type ===
         'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ) {
         let docFile = uploaded[0].name.toString()
         type = docFile.split('.')[1]
      } else {
         type = uploaded[0].type.split('/')[1]
      }
      if (allowed.indexOf(type) > -1) {
         return uploaded[0].name.toString()
      } else {
         alert(
            'סוג מסמך לא נתמך. ניתן להעלות מסמכים עם הסיומות הבאות: "pdf", "xlsx", "doc", "docx", "ppt", "pptx"'
         )
      }
   },
   uploadDocument(file, callback) {
      return new Promise((resolve, reject) => {
         let reader = new FileReader()
         reader.readAsDataURL(file)
         reader.onload = () => {
            return resolve(callback(reader.result))
         }
      })
   },
   getBase64(ev, callback) {
      let uploaded = ev.target.files || ev.dataTransfer.files
      var file = new Image()
      var canvas = document.createElement('canvas')
      var ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      file.onload = () => {
         if (file.width > 1024) {
            file.height *= 1024 / file.width
            file.width = 1024
         }
         canvas.width = file.width
         canvas.height = file.height
         ctx.drawImage(file, 0, 0, file.width, file.height)
         let base64String = canvas.toDataURL(uploaded[0].type, 1)
         callback(base64String)
      }
      file.src = URL.createObjectURL(uploaded[0])
   },
}



// WEBPACK FOOTER //
// ./src/prototypes/oxsfs.js